import gql from "graphql-tag";

export const newsListQuery = gql`
  query newsList($orderBy: OrderBy, $page: Int, $perPage: Int) {
    newsList(orderBy: $orderBy, page: $page, first: $perPage) {
      data {
        id
        name
        isActive
        publishedAt
      }
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
    }
  }
`;
